module.exports = __webpack_public_path__ + "img/scene.69664993.png";